module.exports = __webpack_public_path__ + "media/images/top/feature02-97cb86bb4c07534ff0c5170354cf8b1a.jpg";